const KEYS = typeof window === 'undefined' ? undefined : window.KEYS

export { KEYS }
